import React from "react";
import './index.css';
import { HeaderContainer } from "./containers";

export const LandingPage = () => {
    return (
        <>
        {/* // we are doing flex with the direction being a row for the header elements */}
            <HeaderContainer />
        </>
    )
}